module.exports = __webpack_public_path__ + "img/woman.850c6afb.jpg";